import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BgBox = styled(Box)(() => ({
  backgroundColor: "#FFFFFF",
  borderRadius: "8px",
  padding: "16px",
  letterSpacing: "0.44px",
  color: "#000000",
}));

export const SmallBgBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  borderRadius: "8px",
  padding: "16px",
  letterSpacing: "0.44px",
  color: "#000000",
  width: "300px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "16px",
    marginLeft: "-16px",
  },
}));

export const SmallBgBoxWithoutBg = styled(Box)(({ theme }) => ({
  backgroundColor: "transparent",
  width: "300px",
  padding: "16px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const Titles = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignContent: "center",
});

export const ListItems = styled("ul")({
  listStyleType: "disc",
  marginLeft: "33px",
});

export const InsideListItems = styled("ul")({
  listStyleType: "disc",
  marginLeft: "66px",
});

export const InlineFlexBoxs = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
}));

export const WithoutSeparator = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const Table = styled("table")({
  border: "1px solid black",
  borderCollapse: "collapse",
});

export const Tr = styled("tr")({
  border: "1px solid black",
  textAlign: "center",
});

export const Th = styled("th")({
  width: "180px",
  border: "1px solid black",
});

export const Td = styled("td")({
  border: "1px solid black",
});
